import script from "./TabImagesGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabImagesGlobal.vue?vue&type=script&setup=true&lang=ts"

import "./TabImagesGlobal.vue?vue&type=style&index=0&id=31de3cb5&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31de3cb5"]])

export default __exports__